// @flow

import {ImageSrc, Href} from 'docs/markdoc/attribute-types';
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ElementsHero: MarkdocTagRegistration = {
  tag: 'elements-hero',
  component: 'ElementsHero',
  attributes: {
    title: {
      type: String,
      required: true,
      description: 'Title of hero section',
      localizable: true,
    },
    linkLabel: {
      type: String,
      required: true,
      localizable: true,
      description:
        'Display text for the link that is shown below the description',
    },
    linkHref: {
      type: Href,
      required: true,
      description: 'Href for the link that is shown below the description',
    },
    imageSrc: {
      type: ImageSrc,
      required: true,
      description: 'Path to the image file that is shown',
    },
  },
};
